import { DropdownFilter } from '@carboncopyco/ui';
import { useUrlState } from '../../utils';
import { StatusType, type UrlState } from '../types';

export const StatusFilter = () => {
  const [urlState, setUrlState] = useUrlState<UrlState>({});
  const { active } = urlState;
  const statusOptions = Object.keys(StatusType).map((type) => ({
    id: type,
    label: StatusType[type],
  }));

  return (
    <DropdownFilter
      capsuleWidth={96}
      contentWidth={144}
      items={statusOptions}
      selected={active}
      placeholder="Status"
      onSelect={(active) => {
        setUrlState({
          ...urlState,
          active,
        });
      }}
      onClear={() => setUrlState({ ...urlState, active: undefined })}
    />
  );
};
